import {useCallback} from 'react'
import {MESSAGE_TYPE, MessageContent, MessageModel, SENDER_TYPE} from '../../definitions'
import {
  MessageItemDateRangePicker,
  MessageItemOptionSelect,
  MessageItemLinkBox,
  MessageItemDatePicker,
  MessageItemLink,
  MessageItemDropdownSelect,
  MessageItemTrackingShipment,
  MessageItemText,
  MessageItemSelectService,
  MessageItemReviewOrder,
  MessageItemOrderInfo,
  MessageItemConfirmOrderInfo,
} from '../atoms'
import {toAbsoluteUrl} from '../../../../../_gori/helpers'
import clsx from 'clsx'

export type MessageItemProps = {
  message?: MessageModel<MessageContent>
}
export const MessageItem = ({message}: MessageItemProps) => {
  const messageItemByType = useCallback((message: any) => {
    switch (message.type) {
      case MESSAGE_TYPE.TEXT:
      case MESSAGE_TYPE.SURVEY:
        return <MessageItemText message={message} />
      case MESSAGE_TYPE.DATE_PICKER:
        return <MessageItemDatePicker message={message} />
      case MESSAGE_TYPE.DATE_RANGE_PICKER:
        return <MessageItemDateRangePicker message={message} />
      case MESSAGE_TYPE.OPTION_SELECT:
        return <MessageItemOptionSelect message={message} />
      case MESSAGE_TYPE.DROPDOWN_SELECT:
        return <MessageItemDropdownSelect message={message} />
      case MESSAGE_TYPE.LINK_BOX:
        return <MessageItemLinkBox text={message.content} url={message.url} />
      case MESSAGE_TYPE.LINK:
        return <MessageItemLink text={message.content} url={message.url} />
      case MESSAGE_TYPE.TRACKING_SHIPMENT:
        return <MessageItemTrackingShipment message={message} />
      case MESSAGE_TYPE.SELECT_SERVICE:
        return <MessageItemSelectService message={message} />
      case MESSAGE_TYPE.REVIEW_ORDER:
        return <MessageItemReviewOrder message={message} />
      case MESSAGE_TYPE.ORDER_INFO:
        return <MessageItemOrderInfo message={message} />
      case MESSAGE_TYPE.CONFIRM_ORDER_INFO:
        return <MessageItemConfirmOrderInfo message={message} />
      default:
        return null
    }
  }, [])
  if (!message) return null
  return (
    <>
      {messageItemByType(message)}
      {!!message.error && (
        <div
          className={clsx('chatbot-message-bottom-info d-flex align-items-center gap-1', {
            'align-self-end': message?.sender === SENDER_TYPE.USER,
            'align-self-start': message?.sender === SENDER_TYPE.ASSISTANT,
          })}
        >
          <img alt='err' src={toAbsoluteUrl('/media/gori/invalid.svg')} width={14} height={16} />
          <span className='fs-8 text-danger'>{message.error}</span>
        </div>
      )}
    </>
  )
}
